import { WishListTable } from "../../ui/wish-list-table";

export const AccountWishlist = () => {


    return (
        <>
            <h1 className="section__title">
                Your Video Stories Wishlist
            </h1>
            <WishListTable />
        </>
    );
};

export default AccountWishlist; 